import * as resourceServiceActions from './resourceService'

export default resourceServiceActions
